import Box from '@mui/material/Box';
import {
  AccordionCompetitor,
  AccordionCompetitorProps,
} from './accordion-competitor/AccordionCompetitor';

export type WaitlistProps = {
  data: AccordionCompetitorProps[];
  teamMax: number;
};

export default function Waitlist({ data, teamMax }) {
  return (
    <Box sx={{ py: '24px' }}>
      {data.map((entry, index) => (
        <AccordionCompetitor
          {...entry}
          waitlistPosition={index + 1}
          teamMax={teamMax}
          key={entry.entryId}
        />
      ))}
    </Box>
  );
}
